import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { toast } from '@livable/saas-react-components';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useStore } from 'src/stores';
import { sleep } from 'src/utils/sleep';
export const useBatch = (batchId, callback, startLoader, endLoader, errorText) => {
  const store = useStore();
  const getBatch = async () => {
    const resp = await store.activity.getBatchAsync.run(batchId);
    return resp;
  };
  const checkBatch = async () => {
    startLoader();
    for (let count = 0; count < 15; count++) {
      var _resp$response;
      const resp = await getBatch();
      if ((resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.percentage) === 100) {
        await callback();
        endLoader();
        break;
      } else {
        if (count === 14) {
          toast('error', {
            body: [errorText]
          });
          endLoader();
        }
      }
      await sleep(3000);
    }
  };
  useEffect(() => {
    if (batchId) checkBatch();
  }, [batchId]);
};
export const useDelay = (callback, values, delay) => {
  const isInitial = useRef(false); // do not effect on first rendering
  useEffect(() => {
    if (isInitial.current) {
      const handler = setTimeout(callback, delay);
      return () => clearTimeout(handler);
    }
    isInitial.current = true;
  }, [...values]);
};
export const useURLHandler = (defaltTabName, tabsNames, params) => {
  const location = useLocation();
  const defaultTab = new URLSearchParams(location.search).get('tab') || defaltTabName;
  const getDefaultTab = (defaltName, names) => {
    if (names.includes(defaultTab)) return defaultTab;else return defaltName;
  };
  const _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  const _useState = useState(getDefaultTab(defaltTabName, tabsNames)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleSelectedTabChange = newValue => {
    setSearchParams("?".concat(new URLSearchParams(_objectSpread(_objectSpread({}, params), {}, {
      tab: newValue
    }))));
    setSelectedTab(newValue);
  };
  useEffect(() => {
    setSearchParams("?".concat(new URLSearchParams(_objectSpread(_objectSpread({}, params), {}, {
      tab: selectedTab
    }))));
  }, []);
  useEffect(() => {
    setSelectedTab(searchParams.get('tab') || defaltTabName);
  }, [searchParams]);
  return {
    handleSelectedTabChange,
    selectedTab
  };
};